import { Button } from '@chakra-ui/button';
import Icon from '@chakra-ui/icon';
import { Flex, Heading, Text } from '@chakra-ui/layout';
import {
  AlertDialog,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogOverlay,
} from '@chakra-ui/modal';
import React, { useRef } from 'react';
import { Gift, Mail } from 'react-feather';
import { FirebaseConfig } from '../../../types/types';

interface TrialRegistrationAlertProps {
  onClose: () => void;
  isOpen: boolean;
  onCancel: () => void;
  firebaseConfig: FirebaseConfig;
}

export const TrialRegistrationAlert: React.FC<TrialRegistrationAlertProps> = ({
  isOpen,
  onClose,
  onCancel,
  firebaseConfig,
}) => {
  const focused = useRef(null);
  return (
    <AlertDialog
      colorScheme="brand"
      motionPreset="slideInBottom"
      leastDestructiveRef={focused}
      onClose={onClose}
      isOpen={isOpen}
      isCentered
      size="xl"
    >
      <AlertDialogOverlay />

      <AlertDialogContent p={6} borderRadius="xl" boxShadow="xl">
        <Heading size="md" mb={6}>
          Wir haben dich nicht gefunden.
        </Heading>
        <AlertDialogCloseButton />
        <Flex direction="column" mb={6}>
          <Text mb={2}>
            Leider bist du kein aktives Mitglied im Studio. Dies ist aber kein
            Problem!{' '}
            <span role="img" aria-label="party">
              🥳
            </span>
          </Text>
          <Text>
            Wir schenken dir einen unverbindlichen Zugang zu unserem Angebot für{' '}
            {firebaseConfig.trialExpiration} Tage, sodass du erst einmal schauen
            kannst.
          </Text>
        </Flex>
        <Flex justify="flex-end" direction={['column', 'column', 'row']}>
          <Button
            leftIcon={<Icon as={Mail} />}
            ref={focused}
            onClick={onCancel}
            mb={[3, 3, 0]}
          >
            Andere E-Mail versuchen
          </Button>
          <Button
            leftIcon={<Icon as={Gift} />}
            colorScheme="green"
            ml={[0, 0, 3]}
            onClick={onClose}
          >
            Jetzt kostenlos testen
          </Button>
        </Flex>
      </AlertDialogContent>
    </AlertDialog>
  );
};
